"use client";

import {Login} from "@/components/pages";

const LoginPage = () => {
  return <Login />;
};
export default LoginPage;
